import { forwardRef } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { LastActivityWidget } from '@crehana/compass.dashlets/last-activity-widget';
import { createUrlWithSourceQueryParams } from '@crehana/utils';

import { useLastActivityQuery } from '../hooks/use-last-activity-query/use-last-activity-query';

type TLastActivityUserWidgetProps = {
  dataTestId?: string;
  amplitudeSource: string;
};

const LastActivityUserWidget = forwardRef<
  HTMLDivElement,
  TLastActivityUserWidgetProps
>(
  (
    { dataTestId, amplitudeSource },
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const { logEvent } = useAmplitude();
    const {
      lastActivity,
      error,
      loading: loadingLastActivity,
      refetch: refetchLastActivity,
    } = useLastActivityQuery();

    const handleViewCourse = () => {
      logEvent({
        event: 'HomeUser Action LastActivity Continued',
        data: {
          ...getSourceEventParams(),
          'Course Id': lastActivity?.courseId,
          'Course Progress': lastActivity?.progress,
        },
      });

      window.location.href = createUrlWithSourceQueryParams({
        url: `/clases/v2/${lastActivity?.courseId}/player/`,
        source: amplitudeSource,
      });
    };

    const handleViewDetails = () => {
      window.location.href = createUrlWithSourceQueryParams({
        url: `/clases/v2/${lastActivity?.courseId}/detalle/`,
        source: amplitudeSource,
      });
    };

    return (
      <div ref={ref} data-testid={dataTestId} className="tw-w-full tw-h-full">
        <LastActivityWidget
          item={lastActivity}
          isLoading={loadingLastActivity}
          isError={!!error}
          onRetry={() => refetchLastActivity()}
          onViewCourse={handleViewCourse}
          onViewDetails={handleViewDetails}
        />
      </div>
    );
  },
);

LastActivityUserWidget.displayName = 'LastActivityUserWidget';

export { LastActivityUserWidget };
